import { FlatAspect } from "@/models/HomePageSearchResponse";

export interface CategoryAspect {
  id: string;
  label: string;
  slug: string;
  children: CategoryAspect[];
  isHorses?: boolean;
}

// AJB: this group and flatten business still make sense?
export function FlattenCategories(
  aspects: CategoryAspect[],
  level: number = 0,
  topId: string | null = null
): FlatAspect[] {
  return aspects.flatMap((aspect) => [
    MapCategoryAspectToFlatAspect(aspect, level, topId ?? aspect.id),
    ...FlattenCategories(aspect.children, level + 1, topId ?? aspect.id),
  ]);
}

export function MapCategoryAspectToFlatAspect(
  category: CategoryAspect,
  level: number = 0,
  topId: string | null = null
): FlatAspect {
  return {
    id: category.id.toString(),
    label: category.label,
    level,
    topId: topId ?? category.id,
    slug: category.slug,
  };
}

const CATEGORY_HIERARCHY: CategoryAspect[] = [
  {
    id: "196",
    label: "Horses",
    slug: "horses",
    children: [
      {
        id: "366",
        label: "American Saddlebred",
        slug: "american-saddlebred",
        children: [],
      },
      {
        id: "210",
        label: "Appaloosa",
        slug: "appaloosa",
        children: [],
      },
      {
        id: "211",
        label: "Arabian",
        slug: "arabian",
        children: [],
      },
      {
        id: "360",
        label: "Arabian Derivatives",
        slug: "arabian-derivatives",
        children: [],
      },
      {
        id: "381",
        label: "Australian Stock Horse",
        slug: "australian-stock-horse",
        children: [],
      },
      {
        id: "373",
        label: "Brumby",
        slug: "brumby",
        children: [],
      },
      {
        id: "401",
        label: "Caspian",
        slug: "caspian",
        children: [],
      },
      {
        id: "407",
        label: "Cleveland Bay",
        slug: "cleveland-bay",
        children: [],
      },
      {
        id: "214",
        label: "Clydesdale",
        slug: "clydesdale",
        children: [],
      },
      {
        id: "215",
        label: "Coloured",
        slug: "coloured",
        children: [],
      },
      {
        id: "374",
        label: "Connemara",
        slug: "connemara",
        children: [],
      },
      {
        id: "422",
        label: "Dales Pony",
        slug: "dales-pony",
        children: [],
      },
      {
        id: "217",
        label: "Donkey / Mule",
        slug: "donkey-mule",
        children: [],
      },
      {
        id: "218",
        label: "Draught horse",
        slug: "draught-horse",
        children: [],
      },
      {
        id: "219",
        label: "Friesian",
        slug: "friesian",
        children: [],
      },
      {
        id: "367",
        label: "Galloway",
        slug: "galloway",
        children: [],
      },
      {
        id: "220",
        label: "Gypsy horse",
        slug: "gypsy-horse",
        children: [],
      },
      {
        id: "362",
        label: "Hackney",
        slug: "hackney",
        children: [],
      },
      {
        id: "221",
        label: "Haflinger",
        slug: "haflinger",
        children: [],
      },
      {
        id: "384",
        label: "Irish Draught/Sport Horse",
        slug: "irish-draught-sport-horse",
        children: [],
      },
      {
        id: "379",
        label: "Knabstrupper",
        slug: "knabstrupper",
        children: [],
      },
      {
        id: "223",
        label: "Miniature Horses",
        slug: "miniature-horses",
        children: [],
      },
      {
        id: "410",
        label: "Miniature Ponies",
        slug: "miniature-ponies",
        children: [],
      },
      {
        id: "361",
        label: "Morgan",
        slug: "morgan",
        children: [],
      },
      {
        id: "226",
        label: "Other",
        slug: "other-breeds",
        children: [],
      },
      {
        id: "227",
        label: "Paint",
        slug: "paint",
        children: [],
      },
      {
        id: "228",
        label: "Palomino",
        slug: "palomino",
        children: [],
      },
      {
        id: "229",
        label: "Palouse",
        slug: "palouse",
        children: [],
      },
      {
        id: "363",
        label: "Percheron",
        slug: "percheron",
        children: [],
      },
      {
        id: "230",
        label: "Pinto",
        slug: "pinto",
        children: [],
      },
      {
        id: "232",
        label: "Pony",
        slug: "pony",
        children: [],
      },
      {
        id: "233",
        label: "Quarter horse",
        slug: "quarter-horse",
        children: [],
      },
      {
        id: "234",
        label: "Riding Pony",
        slug: "riding-pony",
        children: [],
      },
      {
        id: "235",
        label: "Shetland",
        slug: "shetland",
        children: [],
      },
      {
        id: "236",
        label: "Shire Horse",
        slug: "shire-horse",
        children: [],
      },
      {
        id: "237",
        label: "Spanish / Andalusian",
        slug: "spanish-andalusian",
        children: [],
      },
      {
        id: "409",
        label: "Spanish Mustangs",
        slug: "spanish-mustangs",
        children: [],
      },
      {
        id: "364",
        label: "Sport Horse",
        slug: "sport-horse",
        children: [],
      },
      {
        id: "377",
        label: "Sportaloosa",
        slug: "sportaloosa",
        children: [],
      },
      {
        id: "238",
        label: "Standardbred",
        slug: "standardbred",
        children: [],
      },
      {
        id: "205",
        label: "Thoroughbred",
        slug: "thoroughbred",
        children: [],
      },
      {
        id: "365",
        label: "Waler",
        slug: "waler",
        children: [],
      },
      {
        id: "240",
        label: "Warmblood",
        slug: "warmblood",
        children: [],
      },
      {
        id: "241",
        label: "Welsh",
        slug: "welsh",
        children: [],
      },
    ],
    isHorses: true,
  },
  {
    id: "197",
    label: "Stallions at Stud",
    slug: "stallions-at-stud",
    children: [
      {
        id: "243",
        label: "Andalusian",
        slug: "andalusian",
        children: [],
      },
      {
        id: "244",
        label: "Appaloosa",
        slug: "appaloosa",
        children: [],
      },
      {
        id: "245",
        label: "Arabian",
        slug: "arabian",
        children: [],
      },
      {
        id: "383",
        label: "Arabian Derivatives",
        slug: "arabian-derivatives",
        children: [],
      },
      {
        id: "382",
        label: "Australian Stock Horse",
        slug: "australian-stock-horse",
        children: [],
      },
      {
        id: "247",
        label: "Brumby / Heritage horse",
        slug: "brumby-heritage-horse",
        children: [],
      },
      {
        id: "399",
        label: "Caspian",
        slug: "caspian",
        children: [],
      },
      {
        id: "406",
        label: "Cleveland Bay",
        slug: "cleveland-bay",
        children: [],
      },
      {
        id: "248",
        label: "Clydesdale",
        slug: "clydesdale",
        children: [],
      },
      {
        id: "249",
        label: "Coloured",
        slug: "coloured",
        children: [],
      },
      {
        id: "397",
        label: "Connemara",
        slug: "connemara",
        children: [],
      },
      {
        id: "250",
        label: "Cross Bred",
        slug: "cross-bred",
        children: [],
      },
      {
        id: "251",
        label: "Donkey / Mule",
        slug: "donkey-mule",
        children: [],
      },
      {
        id: "252",
        label: "Draught horse",
        slug: "draught-horse",
        children: [],
      },
      {
        id: "253",
        label: "Friesian",
        slug: "friesian",
        children: [],
      },
      {
        id: "254",
        label: "Gypsy horse",
        slug: "gypsy-horse",
        children: [],
      },
      {
        id: "255",
        label: "Haflinger",
        slug: "haflinger",
        children: [],
      },
      {
        id: "256",
        label: "Hanoverian",
        slug: "hanoverian",
        children: [],
      },
      {
        id: "385",
        label: "Irish Draught/Sport Horse",
        slug: "irish-draught-sport-horse",
        children: [],
      },
      {
        id: "380",
        label: "Knabstrupper",
        slug: "knabstrupper",
        children: [],
      },
      {
        id: "421",
        label: "Lusitano",
        slug: "lusitano",
        children: [],
      },
      {
        id: "257",
        label: "Miniature",
        slug: "miniature",
        children: [],
      },
      {
        id: "404",
        label: "Morgan",
        slug: "morgan",
        children: [],
      },
      {
        id: "258",
        label: "Non registered horses",
        slug: "non-registered-horses",
        children: [],
      },
      {
        id: "259",
        label: "Other",
        slug: "other-stallions",
        children: [],
      },
      {
        id: "260",
        label: "Paint",
        slug: "paint",
        children: [],
      },
      {
        id: "261",
        label: "Palomino",
        slug: "palomino",
        children: [],
      },
      {
        id: "262",
        label: "Palouse",
        slug: "palouse",
        children: [],
      },
      {
        id: "263",
        label: "Pinto",
        slug: "pinto",
        children: [],
      },
      {
        id: "403",
        label: "Polo / Polocrosse",
        slug: "polo-polocrosse",
        children: [],
      },
      {
        id: "265",
        label: "Pony",
        slug: "pony",
        children: [],
      },
      {
        id: "266",
        label: "Quarter horse",
        slug: "quarter-horse",
        children: [],
      },
      {
        id: "267",
        label: "Riding Pony",
        slug: "riding-pony",
        children: [],
      },
      {
        id: "268",
        label: "Shetland",
        slug: "shetland",
        children: [],
      },
      {
        id: "269",
        label: "Shire Horse",
        slug: "shire-horse",
        children: [],
      },
      {
        id: "408",
        label: "Spanish Mustangs",
        slug: "spanish-mustangs",
        children: [],
      },
      {
        id: "378",
        label: "Sport Horse",
        slug: "sport-horse",
        children: [],
      },
      {
        id: "376",
        label: "Sportaloosa",
        slug: "sportaloosa",
        children: [],
      },
      {
        id: "271",
        label: "Standardbred",
        slug: "standardbred",
        children: [],
      },
      {
        id: "242",
        label: "Thoroughbred",
        slug: "thoroughbred",
        children: [],
      },
      {
        id: "400",
        label: "Waler",
        slug: "waler",
        children: [],
      },
      {
        id: "273",
        label: "Warmblood",
        slug: "warmblood",
        children: [],
      },
      {
        id: "274",
        label: "Welsh",
        slug: "welsh",
        children: [],
      },
    ],
    isHorses: true,
  },
  {
    id: "198",
    label: "Saddlery, Tack & Apparel",
    slug: "saddlery-tack-apparel",
    children: [
      {
        id: "283",
        label: "Bridleware",
        slug: "bridleware",
        children: [
          {
            id: "287",
            label: "Bits",
            slug: "bits",
            children: [],
          },
          {
            id: "284",
            label: "English",
            slug: "english",
            children: [],
          },
          {
            id: "286",
            label: "Other",
            slug: "other-saddlery-tack-apparel",
            children: [],
          },
          {
            id: "285",
            label: "Western",
            slug: "western-saddlery-tack-apparel",
            children: [],
          },
        ],
      },
      {
        id: "301",
        label: "Harness",
        slug: "harness",
        children: [],
      },
      {
        id: "288",
        label: "Riding Accessories",
        slug: "riding-accessories",
        children: [
          {
            id: "294",
            label: "Fly veils",
            slug: "fly-veils",
            children: [],
          },
          {
            id: "289",
            label: "Halters and leads",
            slug: "halters-and-leads",
            children: [],
          },
          {
            id: "291",
            label: "Helmets",
            slug: "helmets",
            children: [],
          },
          {
            id: "292",
            label: "Horse Boots",
            slug: "horse-boots",
            children: [],
          },
          {
            id: "298",
            label: "Other",
            slug: "other-riding-accessories",
            children: [],
          },
          {
            id: "293",
            label: "Rugs",
            slug: "rugs",
            children: [],
          },
          {
            id: "297",
            label: "Saddle accessories",
            slug: "saddle-accessories",
            children: [],
          },
          {
            id: "290",
            label: "Saddle cloths",
            slug: "saddle-cloths",
            children: [],
          },
          {
            id: "295",
            label: "Spurs",
            slug: "spurs",
            children: [],
          },
          {
            id: "296",
            label: "Whips",
            slug: "whips",
            children: [],
          },
        ],
      },
      {
        id: "299",
        label: "Riding Apparel",
        slug: "riding-apparel",
        children: [
          {
            id: "310",
            label: "Chaps and chappettes",
            slug: "chaps-and-chappettes",
            children: [],
          },
          {
            id: "309",
            label: "Clothing accessories",
            slug: "clothing-accessories",
            children: [],
          },
          {
            id: "308",
            label: "General clothing",
            slug: "general-clothing",
            children: [],
          },
          {
            id: "312",
            label: "Gloves",
            slug: "gloves",
            children: [],
          },
          {
            id: "307",
            label: "Hats",
            slug: "hats",
            children: [],
          },
          {
            id: "306",
            label: "Jacket and vests",
            slug: "jacket-and-vests",
            children: [],
          },
          {
            id: "304",
            label: "Jodhpurs",
            slug: "jodhpurs",
            children: [],
          },
          {
            id: "313",
            label: "Other",
            slug: "other-riding-apparel",
            children: [],
          },
          {
            id: "311",
            label: "Riding Boots",
            slug: "riding-boots",
            children: [],
          },
          {
            id: "305",
            label: "Shirts",
            slug: "shirts",
            children: [],
          },
          {
            id: "303",
            label: "Wet weather gear",
            slug: "wet-weather-gear",
            children: [],
          },
        ],
      },
      {
        id: "300",
        label: "Riding equipment",
        slug: "riding-equipment",
        children: [
          {
            id: "315",
            label: "Dressage arena markers",
            slug: "dressage-arena-markers",
            children: [],
          },
          {
            id: "314",
            label: "Jumps",
            slug: "jumps",
            children: [],
          },
          {
            id: "319",
            label: "Other",
            slug: "other-riding-equipment",
            children: [],
          },
          {
            id: "317",
            label: "Polo equipment",
            slug: "polo-equipment",
            children: [],
          },
          {
            id: "316",
            label: "Polocrosse equipment",
            slug: "polocrosse-equipment",
            children: [],
          },
          {
            id: "318",
            label: "Timing equipment",
            slug: "timing-equipment",
            children: [],
          },
        ],
      },
      {
        id: "275",
        label: "Saddles",
        slug: "saddles",
        children: [
          {
            id: "278",
            label: "All purpose",
            slug: "all-purpose",
            children: [],
          },
          {
            id: "281",
            label: "Children",
            slug: "children",
            children: [],
          },
          {
            id: "276",
            label: "Dressage and Show",
            slug: "dressage-and-show",
            children: [],
          },
          {
            id: "277",
            label: "Jumping",
            slug: "jumping",
            children: [],
          },
          {
            id: "282",
            label: "Other",
            slug: "other-saddles",
            children: [],
          },
          {
            id: "280",
            label: "Stock",
            slug: "stock",
            children: [],
          },
          {
            id: "279",
            label: "Western",
            slug: "western-saddles",
            children: [],
          },
        ],
      },
      {
        id: "302",
        label: "Training equipment",
        slug: "training-equipment",
        children: [],
      },
    ],
  },
  {
    id: "199",
    label: "Equine & Farm Equipment",
    slug: "equine-farm-equipment",
    children: [
      {
        id: "336",
        label: "Farm accessories",
        slug: "farm-accessories",
        children: [
          {
            id: "337",
            label: "Arenas",
            slug: "arenas",
            children: [],
          },
          {
            id: "338",
            label: "Barns/Shed/Stabling",
            slug: "barns-shed-stabling",
            children: [],
          },
          {
            id: "344",
            label: "Fencing",
            slug: "fencing",
            children: [],
          },
          {
            id: "339",
            label: "Pools",
            slug: "pools",
            children: [],
          },
          {
            id: "343",
            label: "Portable yards",
            slug: "portable-yards",
            children: [],
          },
          {
            id: "340",
            label: "Sheds",
            slug: "sheds",
            children: [],
          },
          {
            id: "341",
            label: "Stabling",
            slug: "stabling",
            children: [],
          },
          {
            id: "368",
            label: "Training Track",
            slug: "training-track",
            children: [],
          },
          {
            id: "342",
            label: "Water troughs",
            slug: "water-troughs",
            children: [],
          },
        ],
      },
      {
        id: "206",
        label: "Horse accessories",
        slug: "horse-accessories",
        children: [
          {
            id: "208",
            label: "Boots and Bandages",
            slug: "boots-and-bandages",
            children: [],
          },
          {
            id: "345",
            label: "Clippers and accessories",
            slug: "clippers-and-accessories",
            children: [],
          },
          {
            id: "346",
            label: "Farrier tools",
            slug: "farrier-tools",
            children: [],
          },
          {
            id: "348",
            label: "Feed supplies and accessories",
            slug: "feed-supplies-and-accessories",
            children: [],
          },
          {
            id: "347",
            label: "Foaling supplies",
            slug: "foaling-supplies",
            children: [],
          },
          {
            id: "207",
            label: "Grooming equipment",
            slug: "grooming-equipment",
            children: [],
          },
          {
            id: "349",
            label: "Horse health",
            slug: "horse-health",
            children: [],
          },
          {
            id: "350",
            label: "Other",
            slug: "other-horse-accessories",
            children: [],
          },
        ],
      },
      {
        id: "369",
        label: "Motor/quad bikes",
        slug: "motor-quad-bikes",
        children: [],
      },
      {
        id: "372",
        label: "Other",
        slug: "other-equine-farm-equipment",
        children: [],
      },
      {
        id: "371",
        label: "Ride-on mowers",
        slug: "ride-on-mowers",
        children: [],
      },
      {
        id: "335",
        label: "Stable accessories",
        slug: "stable-accessories",
        children: [
          {
            id: "351",
            label: "Feeding equipment",
            slug: "feeding-equipment",
            children: [],
          },
          {
            id: "355",
            label: "Other",
            slug: "other-stable-accessories",
            children: [],
          },
          {
            id: "352",
            label: "Saddle racks",
            slug: "saddle-racks",
            children: [],
          },
          {
            id: "353",
            label: "Tools",
            slug: "tools",
            children: [],
          },
          {
            id: "354",
            label: "Wheel barrows",
            slug: "wheel-barrows",
            children: [],
          },
        ],
      },
      {
        id: "370",
        label: "Tractors",
        slug: "tractors",
        children: [],
      },
    ],
  },
  {
    id: "201",
    label: "Transport & Vehicles",
    slug: "transport-vehicles",
    children: [
      {
        id: "356",
        label: "Floats & Accessories",
        slug: "floats-accessories",
        children: [],
      },
      {
        id: "359",
        label: "Other",
        slug: "other-transport-vehicles",
        children: [],
      },
      {
        id: "357",
        label: "Towing Vehicles",
        slug: "towing-vehicles",
        children: [],
      },
      {
        id: "358",
        label: "Trucks",
        slug: "trucks",
        children: [],
      },
    ],
  },
  {
    id: "202",
    label: "Equine Property",
    slug: "equine-property",
    children: [
      {
        id: "396",
        label: "Agistment",
        slug: "agistment",
        children: [],
      },
      {
        id: "395",
        label: "For Lease/Rent",
        slug: "for-lease-rent",
        children: [],
      },
      {
        id: "393",
        label: "For Sale",
        slug: "property-for-sale",
        children: [],
      },
    ],
  },
  {
    id: "204",
    label: "Giftware & Resources",
    slug: "giftware-resources",
    children: [
      {
        id: "324",
        label: "Art",
        slug: "art",
        children: [],
      },
      {
        id: "331",
        label: "Books/Videos/DVDs",
        slug: "books-videos-dvds",
        children: [
          {
            id: "333",
            label: "Education/Training",
            slug: "education-training",
            children: [],
          },
          {
            id: "332",
            label: "Fiction",
            slug: "fiction",
            children: [],
          },
          {
            id: "334",
            label: "Veterinary",
            slug: "veterinary",
            children: [],
          },
        ],
      },
      {
        id: "325",
        label: "Clothing",
        slug: "clothing",
        children: [],
      },
      {
        id: "329",
        label: "Collectibles",
        slug: "collectibles",
        children: [],
      },
      {
        id: "326",
        label: "Jewellery",
        slug: "jewellery",
        children: [],
      },
      {
        id: "330",
        label: "Memorabilia",
        slug: "memorabilia",
        children: [],
      },
      {
        id: "327",
        label: "Novelty",
        slug: "novelty",
        children: [],
      },
      {
        id: "328",
        label: "Other",
        slug: "other-giftware-resources",
        children: [],
      },
    ],
  },
  {
    id: "375",
    label: "Horse Care Product",
    slug: "horse-care-products",
    children: [],
  },
  {
    id: "412",
    label: "Retail Zone",
    slug: "retail-zone",
    children: [
      {
        id: "417",
        label: "Apparel",
        slug: "apparel",
        children: [],
      },
      {
        id: "413",
        label: "Feed",
        slug: "feed",
        children: [],
      },
      {
        id: "418",
        label: "Property Improvements",
        slug: "property-improvements",
        children: [],
      },
      {
        id: "416",
        label: "Saddlery",
        slug: "saddlery",
        children: [],
      },
      {
        id: "420",
        label: "Stables",
        slug: "stables",
        children: [],
      },
      {
        id: "414",
        label: "Supplements",
        slug: "supplements",
        children: [],
      },
      {
        id: "415",
        label: "Therapy",
        slug: "therapy",
        children: [],
      },
      {
        id: "419",
        label: "Transport",
        slug: "transport",
        children: [],
      },
    ],
  },
];

export default CATEGORY_HIERARCHY;
